import React, { useState, useEffect } from 'react';
import { Form, Button, Modal } from '@themesberg/react-bootstrap';
import axiosInstance from "../../../api/api";
import ReactQuill from "react-quill";

const EditForm = ({ id, show, handleClose, onAdd }) => {
    const [formData, setFormData] = useState({
        id: "",
        description: "",
        value: "",
        type: "",
        tooltip: "",
        modal: "",
        link: "",// Usar el option pasado por props
        option: "",
        orden: "",
        grupo: ""
    });

    useEffect(() => {
        console.log(id)
        if (id) {
            axiosInstance.get(`/detailoption/${id}`)
                .then(response => {
                    setFormData(response.data.data);
                    console.log(response.data.data)
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleModal = (value) => {
        setFormData({
            ...formData,
            ["modal"]: value,
        });
    };

    const handleTooltip = (value) => {
        setFormData({
            ...formData,
            ["tooltip"]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.description || !formData.value) {
            alert('Por favor, completa todos los campos obligatorios.');
            return;
        }
        axiosInstance.post(`/detailoption/`, formData)
            .then(() => {
                alert("Datos actualizados correctamente");
                onAdd();
                handleClose();
            })
            .catch(error => {
                console.error("Error updating data:", error);
            });
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Editar Registro</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            type="text"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group controlId="formValue">
                        <Form.Label>Value</Form.Label>
                        <Form.Control
                            type="text"
                            name="value"
                            value={formData.value}
                            onChange={handleChange}
                            required
                            readOnly
                        />
                    </Form.Group>

                    <Form.Group controlId="formType">
                        <Form.Label>Type</Form.Label>
                        <Form.Control
                            as="select"
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            required
                        >
                            <option value="text">Text</option>
                            <option value="number">Number</option>
                            <option value="date">Date</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="formTooltip" style={{ height: '200px' }}>
                        <Form.Label>Tooltip</Form.Label>
                        <ReactQuill
                            value={formData.tooltip || ''}
                            style={{ height: '120px' }}
                            onChange={handleTooltip}
                            name="tooltip"
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline', 'strike'], // Formato básico
                                    ['list', 'bullet', 'indent', '-1', '+1'], // Listas
                                    ['link', 'image', 'video'], // Enlaces e imágenes
                                ],
                            }}
                        />
                    </Form.Group>

                    <Form.Group controlId="formModal"
                        style={{ height: '200px' }}>
                        <Form.Label>Modal</Form.Label>
                        <ReactQuill
                            value={formData.modal || ''}
                            style={{ height: '120px' }}
                            onChange={handleModal}
                            name="modal"
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline', 'strike'], // Formato básico
                                    ['list', 'bullet', 'indent', '-1', '+1'], // Listas
                                    ['link', 'image', 'video'], // Enlaces e imágenes
                                ],
                            }}
                        />
                    </Form.Group>
                    <Form.Group controlId="formLink">
                        <Form.Label>Link</Form.Label>
                        <Form.Control
                            type="text"
                            name="link"
                            value={formData.link || ''}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group controlId="numberSelect">
                        <Form.Label>Selecciona un orden de visualizacion del 1 al 10</Form.Label>
                        <Form.Select name="orden" value={formData.orden} onChange={handleChange}>
                            <option value="">Selecciona...</option>
                            {[...Array(10)].map((_, i) => (
                                <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group controlId="numberSelect">
                        <Form.Label>Selecciona un grupo</Form.Label>
                        <Form.Select name="grupo" value={formData.grupo} onChange={handleChange}>
                            <option value="">Selecciona...</option>
                            <option value="clientes">Clientes</option>
                            <option value="empleado">Empleados y costos indirectos</option>
                            <option value="inversion">Inversiones</option>
                        </Form.Select>
                    </Form.Group>



                    <Button variant="primary" type="submit" className="mt-3">
                        Guardar Cambios
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditForm;